export default [
    {
        path: "roles-area",
        name: "settings-roles-area",
        redirect: { name: "settings-roles-area-roles" },
        component: () => import("@/views/settings/views/roles-area/RolesArea.vue"),
        meta: {
            section: 19,
            pageTitle: "Settings",
            breadcrumb: [
                {
                    text: "Roles",
                    active: true,
                },
            ],

            tabs: [
                {
                    title: "Roles",
                    name: "settings-roles-area-roles",
                },
                {
                    title: "Areas",
                    name: "settings-roles-area-list",
                },
            ],
        },

        children: [
            {
                path: "roles",
                name: "settings-roles-area-roles",
                component: () => import("@/views/settings/views/roles-area/components/RolesTable.vue"),
                meta: {
                    section: 19,
                    tab: "role",
                    pageTitle: "Roles by Area",
                    breadcrumb: [
                        {
                            text: "Roles",
                            active: true,
                        },
                    ],
                },
            },
            {
                path: "areas",
                name: "settings-roles-area-list",
                component: () => import("@/views/settings/views/roles-area/components/AreasTable.vue"),
                meta: {
                    section: 19,
                    tab: "area",
                    pageTitle: "Roles by Area",
                    breadcrumb: [
                        {
                            text: "Areas",
                            active: true,
                        },
                    ],
                },
            },
        ],
    },
];